// extracted by mini-css-extract-plugin
export default {"container":"NotUpToDate_container__KnPfM","title":"NotUpToDate_title__iMaN1","link":"NotUpToDate_link__rjJhe","with-photos":"NotUpToDate_with-photos__94amI"};